module.exports = __webpack_public_path__ + "img/construir_muros_de_ladrillo.bbd7229f.png";